import api from './api';

const donationsService = {
  async getAll() {
    const response = await api.get('/donations');
    return response.data;
  },

  async getOne(id) {
    const response = await api.get(`/donations/${id}`);
    return response.data;
  },

  // Criação pública (anónima ou não)
  async create(data) {
    const response = await api.post('/donations', data);
    return response.data;
  },

  // Atualizar estado (PENDING → COMPLETED, etc.)
  async update(id, data) {
    const response = await api.patch(`/donations/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/donations/${id}`);
    return response.data;
  },
};

export default donationsService;
